import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookmark,
  faBookmark as faBookmarkSolid,
} from "@fortawesome/free-solid-svg-icons";
import "./Tile.css";
import { useAppSelector } from "../../app/store";
import { handleTileClickEventBuilder, sendEvent } from "../../utils/event-helpers";
import { useWithSessionData } from "../../hooks/use-with-session-data";

export interface TileProps {
  id: string;
  title: string;
  description: any;
  thumbnail: string;
  url: string;
  isResearchPage: boolean;
  onBookmark: () => void;
}

const Tile = ({
  id,
  title,
  description,
  thumbnail,
  url,
  isResearchPage,
  onBookmark,
}: TileProps) => {
  const { userId, sessionId } = useWithSessionData();
  const bookmarkedResources = useAppSelector(
    (state) => state.resourceBookmarks.bookmarkedResources
  );
  const isBookmarked = bookmarkedResources.some((item) => item.title === title);

  const renderDescription = () => {
    if (typeof description === "string") {
      return <p className="tile-description">{description}</p>;
    } else if (description && description.content) {
      return (
        <p className="tile-description">
          {description.content[0]?.content[0]?.value ||
            "No description available"}
        </p>
      );
    }
    return <p className="tile-description">No description available</p>;
  };

  const handleClickTile = () => {
    const eventData = handleTileClickEventBuilder(userId, sessionId, title, {});
    sendEvent(eventData);
  };

  return (
    <div
      className={`tile ${isResearchPage ? "research-page-tile" : ""}`}
    >
      <div className="tile-content">
        <a onClick={handleClickTile} href={url} target="_blank" rel="noopener noreferrer">
          <img src={thumbnail} alt={title} className="tile-thumbnail" />
        </a>
        <h3 className="tile-title">{title}</h3>
        {renderDescription()}
        <button
          onClick={onBookmark}
          className="bookmark-button"
          aria-label={isBookmarked ? "Remove bookmark" : "Add bookmark"}
        >
          <FontAwesomeIcon
            icon={isBookmarked ? faBookmarkSolid : faBookmark}
            className={`bookmark-icon ${isBookmarked ? "blue" : "white"}`}
          />
        </button>
      </div>
    </div>
  );
};

export default Tile;
